import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChestStatus } from './chest-status';

@Injectable({
  providedIn: 'root'
})
export class TreasureService {

  constructor(private http: HttpClient) { }

  isAllowOpen(): Observable<ChestStatus> {

    const url = (environment.production) ?
    (environment.apiBaseUrl + 'Theasure/isAllowOpen') :
    (environment.apiBaseUrl + 'Theasure/isAllowOpen2242');

    return this.http.get(url) as Observable<ChestStatus>;

  }

  openChest(): Observable<{Success: boolean; Message: string}> {

    const url = (environment.production) ?
    (environment.apiBaseUrl + 'Theasure/OpenTheasureBox') :
    (environment.apiBaseUrl + 'Theasure/OpenTheasureBox2242');

    return this.http.get(url) as Observable<{Success: boolean; Message: string}>;
  }
}
